import React from 'react'
import style from './style.module.scss'
import PropTypes from 'prop-types'
import { getImgURL } from '@shared-submodule/utils'
import CustomLink from '@shared/components/customLink'
import MyImage from '@shared/components/myImage'

const Card = ({ news, isMobile }) => {
  return (
    <div className={style.card}>
      {news?.map((news, i) => {
        if (!isMobile) {
          return (
            <React.Fragment key={i}>
            <CustomLink href={`/${news?.oSeo?.sSlug}`} key={i}>
              <a>
                <div className='d-flex flex-column align-items-center absolute cursor-pointer' >
                  <MyImage src={getImgURL(news?.oImg?.sUrl)} alt={news?.sTitle} width={410} height={256} className={style.cardBox} />
                  <div className={style.paraBox}>
                    <p className={style.textPara}>{news?.sTitle.slice(0, 70)}...</p>
                    <div className={style.date}>
                      <span>IPL 2025</span>
                      <span>{new Date(news?.dPublishDate).toLocaleString('en-US', {
                        weekday: 'short',
                        day: 'numeric',
                        month: 'short'
                      })}</span>
                    </div>
                  </div>
                </div>
              </a>
            </CustomLink>
            </React.Fragment>
          )
        } else {
          return (
            <div className='d-flex flex-column align-items-center absolute' key={i} >
              <MyImage src={getImgURL(news?.oImg?.sUrl)} alt={news?.sTitle} width={380} height={256} className={style.cardBox} />
              <div className={style.paraBox}>
                <p className={style.textPara}>{news?.sTitle.slice(0, 50)}...</p>
                <div className={style.date}>
                  <span>IPL 2025</span>
                  <span>{new Date(news?.dPublishDate).toLocaleString('en-US', {
                    weekday: 'short',
                    day: 'numeric',
                    month: 'short'
                  })}</span>
                </div>
              </div>
            </div>
          )
        }
      })}
    </div>
  )
}

Card.propTypes = {
  news: PropTypes.array,
  isMobile: PropTypes.bool
}

export default Card
